import servicesList from './List'
import servicesCreate from './Create'
import servicesEdit from './Edit'

const servicesResource = {
  list: servicesList,
  create: servicesCreate,
  edit: servicesEdit,
}

export default servicesResource
